import IAction from "models/IAction";
import BaseReducer from "../../utilities/BaseReducer";
import INotificheState from "./models/INotificheState";
import PreventiviConFirmaDigitaleModel from "./models/PreventiviConFirmaDigitaleModel";
import PreventiviInScadenzaModel from "./models/PreventiviInScadenzaModel";
import NotificheAction from "./NotificheAction";
import AppointmentModel from "./models/AppointmentModel";

export default class NotificheReducer extends BaseReducer<INotificheState> {
    public readonly initialState: INotificheState = {
        preventiviInScadenza: [],
        preventiviInScadenzaTotal: 0,
        preventiviConFirmaDigitale: [],
        preventiviConFirmaDigitaleTotal: 0,
        appointments: [],
        appointmentsTotal: 0,
    };

    public [NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_EXPIRING_ESTIMATE_FINISHED](
        state: INotificheState,
        action: IAction<PreventiviInScadenzaModel[]>
    ): INotificheState {
        return {
            ...state,
            preventiviInScadenza: action.payload!,
            preventiviInScadenzaTotal: action.payload?.length!,
        };
    }

    public [NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_DIGITAL_SIGNED_DOCUMENTS_FINISHED](
        state: INotificheState,
        action: IAction<PreventiviConFirmaDigitaleModel[]>
    ): INotificheState {
        return {
            ...state,
            preventiviConFirmaDigitale: action.payload!,
            preventiviConFirmaDigitaleTotal: action.payload?.length!,
        };
    }

    public [NotificheAction.REQUEST_SIMULAZIONE_NOTIFICHE_GET_APPOINTMENTS_FINISHED](
        state: INotificheState,
        action: IAction<AppointmentModel[]>
    ): INotificheState {
        return {
            ...state,
            appointments: action.payload!,
            appointmentsTotal: action.payload?.length!,
        };
    }
}
